/**
 * Created by jiachenpan on 16/11/18.
 */

import store from "../store";
import request from "@/utils/request";

import { return2Num as return2Num0 } from "@/utils/calendarData";
import {
  findDdItme,
  findDdItmeMap,
  findDdItmeByChars,
  erpFindDdItmeByChars
} from "@/api/dataDic";
import { findDdItmeByCharsCrm } from "@/api/crm/common.js";
import { todoPageWeb, getOAMaopao, getGreenMaopao, getQualityMaopao, getCleanOrderMaopao, getJobDescriptionMaopao } from "@/api/processMan";
import { getAdeLeaveRecordNum } from "@/api/processMan/marriageAndFuneralLeaveReissueApi";
import { postAction, getAction } from "@/api";
const Qs = require("qs");

export function return2Num(val) {
  return return2Num0(val);
}
// 金额转大写
export function convertCurrency(money) {
  //汉字的数字
  var cnNums = new Array(
    "零",
    "壹",
    "贰",
    "叁",
    "肆",
    "伍",
    "陆",
    "柒",
    "捌",
    "玖"
  );
  //基本单位
  var cnIntRadice = new Array("", "拾", "佰", "仟");
  //对应整数部分扩展单位
  var cnIntUnits = new Array("", "万", "亿", "兆");
  //对应小数部分单位
  var cnDecUnits = new Array("角", "分", "毫", "厘");
  //整数金额时后面跟的字符
  var cnInteger = "整";
  //整型完以后的单位
  var cnIntLast = "元";
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  //金额整数部分
  var integerNum;
  //金额小数部分
  var decimalNum;
  //输出的中文金额字符串
  var chineseStr = "";
  //分离金额后用的数组，预定义
  var parts;
  if (money == "") {
    return "";
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return "";
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf(".") == -1) {
    integerNum = money;
    decimalNum = "";
  } else {
    parts = money.split(".");
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == "0") {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != "") {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != "0") {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == "") {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == "") {
    chineseStr += cnInteger;
  }
  return chineseStr;
}

// 保存tab index
export function setSessionTabIndex(route, tabIndex) {
  let pagePath = route.path;

  if (pagePath.indexOf("/:") >= 0) {
    pagePath = pagePath.split("/:")[0];
  }
  pagePath = pagePath.replace(/\//g, "");
  let sessionTabIndexMap = window.sessionStorage.sessionTabIndexMap;
  if (sessionTabIndexMap) {
    sessionTabIndexMap = JSON.parse(window.sessionStorage.sessionTabIndexMap);
  } else {
    sessionTabIndexMap = {};
  }
  sessionTabIndexMap[pagePath] = tabIndex;
  window.sessionStorage.sessionTabIndexMap = JSON.stringify(sessionTabIndexMap);
}
// 读取tab index
export function getSessionTabIndex(route) {
  let tabIndex = 0;
  let pagePath = route.path;
  if (pagePath.indexOf("/:") >= 0) {
    pagePath = pagePath.split("/:")[0];
  }
  pagePath = pagePath.replace(/\//g, "");
  let sessionTabIndexMap = window.sessionStorage.sessionTabIndexMap;
  if (sessionTabIndexMap) {
    sessionTabIndexMap = JSON.parse(window.sessionStorage.sessionTabIndexMap);
    if (sessionTabIndexMap[pagePath]) {
      tabIndex = sessionTabIndexMap[pagePath];
    }
  }

  return tabIndex;
}

/**
 * @获取屏幕dpi
 * */
export function getDpi() {
  var arrDPI = [];
  if (window.screen.deviceXDPI) {
    arrDPI[0] = window.screen.deviceXDPI;
    arrDPI[1] = window.screen.deviceYDPI;
  } else {
    var tmpNode = document.createElement("DIV");
    tmpNode.style.cssText =
      "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
    document.body.appendChild(tmpNode);
    arrDPI[0] = parseInt(tmpNode.offsetWidth);
    arrDPI[1] = parseInt(tmpNode.offsetHeight);
    tmpNode.parentNode.removeChild(tmpNode);
  }
  return arrDPI;
}

/**
 * 获取屏幕dpi宽度
 * */
export function getDpiWidth(width) {
  var screen_dpi = getDpi();
  var dpi_width = (width / 25.4) * screen_dpi[0];
  return parseInt(dpi_width);
}

/**
 * 获取屏幕dpi高度
 * */
export function getDpiHeight(height) {
  var screen_dpi = getDpi();
  var dpi_height = (height / 25.4) * screen_dpi[1];
  return parseInt(dpi_height);
}

// obj转成qs
export function object2qs(obj) {
  return Qs.stringify(obj);
}
export function isNumber(val) {
  let numReg = /^\-?\d+$|^\-?\d+\.\d+$/;
  return numReg.test(val);
}

// 对数字进行四舍五入
export function num2Round(num, digit = 2) {
  if (!isNull(num)) {
    num = parseFloat(num);
    let digitNum = 1;
    for (let i = 0; i < digit; i++) {
      digitNum += "0";
    }
    digitNum = parseInt(digitNum);

    let newNum = Math.round(num * digitNum) / digitNum;
    return newNum;
  } else {
    return "";
  }
}

// 获取当前日期前/后 n (年/月/日) 的日期
export function getDateAfterCurDate(curDateStr, type, number, symbol) {
  let curDate = new Date(curDateStr);
  if (type == "y") {
    if (symbol == "+") {
      curDate.setFullYear(curDate.getFullYear() + number);
    } else if ((symbol = "-")) {
      curDate.setFullYear(curDate.getFullYear() - number);
    }
  } else if (type == "m") {
    if (symbol == "+") {
      curDate.setMonth(curDate.getMonth() + number);
    } else if ((symbol = "-")) {
      curDate.setMonth(curDate.getMonth() - number);
    }
  } else if (type == "d") {
    if (symbol == "+") {
      curDate.setDate(curDate.getDate() + number);
    } else if ((symbol = "-")) {
      curDate.setDate(curDate.getDate() - number);
    }
  }
  return formatDate(curDate);
}

// 获取当月天数
export function mGetDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var d = new Date(year, month, 0);
  return d.getDate();
}
// 获取当前日期 2019-01-01
export function getToday() {
  let today = new Date();
  let year = today.getFullYear();
  let month = return2Num(today.getMonth() + 1);
  let day = return2Num(today.getDate());
  return `${year}-${month}-${day}`;
}
export function getToday2(dateObj) {
  let today = new Date();
  if (dateObj) {
    today = dateObj;
  }
  let year = today.getFullYear();
  let month = return2Num(today.getMonth() + 1);
  let day = return2Num(today.getDate());
  return `${year}-${month}-${day}`;
}

// 获取当前日期前一天/后一天
export function getNextDate(date, diff) {
  let now = isNull(date) ? new Date() : new Date(date);
  now.setDate(now.getDate() + diff);
  let year = now.getFullYear();
  let month = return2Num(now.getMonth() + 1);
  let day = return2Num(now.getDate());
  return `${year}-${month}-${day}`;
}

// 获取周几
export function getWeek(date) {
  let weekList = ["日", "一", "二", "三", "四", "五", "六"];
  return weekList[new Date(date).getDay()];
}

// 日期 获取本月第一天到今天
export function returnToMonth() {
  let newDate = new Date();
  let year = newDate.getFullYear();
  let month = return2Num(newDate.getMonth() + 1);
  let today = return2Num(newDate.getDate());
  let times = [`${year}-${month}-01`, `${year}-${month}-${today}`];
  return times;
}

// 获取当前时间 2019-01-01 00:00:00
export function getCurTime() {
  let today = new Date();
  let year = today.getFullYear();
  let month = return2Num(today.getMonth() + 1);
  let day = return2Num(today.getDate());
  let hour = return2Num(today.getHours());
  let minute = return2Num(today.getMinutes());
  let second = return2Num(today.getSeconds());
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

// 获取当前时间 2019-01-01
export function getCurTimeYMD() {
  let today = new Date();
  let year = today.getFullYear();
  let month = return2Num(today.getMonth() + 1);
  let day = return2Num(today.getDate());
  let hour = return2Num(today.getHours());
  let minute = return2Num(today.getMinutes());
  let second = return2Num(today.getSeconds());
  return `${year}-${month}-${day}`;
}

// 格式化时间戳
export function formatTimestamp(timestamp) {
  timestamp = typeof timestamp === "string" ? Number(timestamp) : timestamp;
  let today = new Date(timestamp);
  let year = today.getFullYear();
  let month = return2Num(today.getMonth() + 1);
  let day = return2Num(today.getDate());
  let hour = return2Num(today.getHours());
  let minute = return2Num(today.getMinutes());
  let second = return2Num(today.getSeconds());
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}
// 身份证号获取个人信息
// if (sfzReg.test(val)) {
//   let info = utils.getInfoByIDCard(val)
//   this.dlgData.sex = info.sex == '1' ? '男' : '女'
//   this.dlgData.age = info.age
// } else {
//   this.dlgData.sex = ''
//   this.dlgData.age = ''
// }
export function getInfoByIDCard(idCard) {
  let now = new Date();
  let month = now.getMonth() + 1;
  let day = now.getDate();
  let birthDate = "";
  let age = 0;
  let sex = 1;
  if (idCard.length == 18) {
    birthDate =
      idCard.substring(6, 10) +
      "-" +
      idCard.substring(10, 12) +
      "-" +
      idCard.substring(12, 14);
    sex = parseInt(idCard.substr(16, 1)) % 2;
    if (sex != 1) sex = 2;
    age = now.getFullYear() - idCard.substring(6, 10) - 1;
    if (
      idCard.substring(10, 12) < month ||
      (idCard.substring(10, 12) == month && idCard.substring(12, 14) <= day)
    ) {
      age++;
    }
  }
  return {
    birthDate,
    sex,
    age
  };
}

// 阿里图片，ios 横向的，转成正常的
export function imgToNormal(imgUrl) {
  if (!imgUrl.includes("?x-oss-process=image")) {
    // return imgUrl + "?x-oss-process=image/resize,w_300/auto-orient,1";
    return imgUrl + "?x-oss-process=image/auto-orient,1";
  } else {
    return imgUrl;
  }
}

// 图片转对象
export function imgUrl2Obj(url) {
  let name = url.split("/");
  name = name[name.length - 1];
  let type = name.split(".")[1];
  if (type != "wav") type = "image";
  let obj = {
    type,
    url,
    name
  };
  return obj;
}

// 发送数据，表单形式
export function requestForm(url, method, data) {
  return request({
    url: url,
    method,
    headers: {
      "Content-Type": "multipart/form-data"
    },

    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        ret = ret.substr(0, ret.length - 1);
        return ret;
      }
    ],
    data
  });
}

// 上传excel 发送数据
export function requestExcel(url, data) {
  let formData = new FormData();
  for (let key in data) {
    let value = data[key];
    formData.append(key, value);
  }
  // console.log("dddd", formData);

  return request({
    url,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: formData
  });
}

export function num2week(num) {
  let week = "";
  switch (num) {
    case "0":
      week = "周日";
      break;
    case "1":
      week = "周一";
      break;
    case "2":
      week = "周二";
      break;
    case "3":
      week = "周三";
      break;
    case "4":
      week = "周四";
      break;
    case "5":
      week = "周五";
      break;
    case "6":
      week = "周六";
      break;
  }
  return week;
}

// 获取数据字典数据
export function getDataDict(scope, groupChar, key) {
  let sendObj = {
    groupChar,
    page: 1,
    size: 500
  };
  findDdItme(sendObj).then(res => {
    let list = res.data.list;

    let newArr = [];
    for (let item of list) {
      let newObj = {
        id: item.itemValue + "",
        name: item.itemText
      };
      newArr.push(newObj);
    }
    scope[key] = newArr;
  });
}
// 获取数据字典数据
export function getDataDictNum(scope, groupChar, key) {
  let sendObj = {
    groupChar,
    page: 1,
    size: 500
  };
  findDdItme(sendObj).then(res => {
    let list = res.data.list;

    let newArr = [];
    for (let item of list) {
      let newObj = {
        id: parseInt(item.itemValue),
        name: item.itemText
      };
      newArr.push(newObj);
    }
    scope[key] = newArr;
  });
}

// 获取数据字典数据并按itemValue从小到大排序
export function getDataDictNumSorted(scope, groupChar, key) {
  let sendObj = {
    groupChar,
    page: 1,
    size: 500
  };
  findDdItme(sendObj).then(res => {
    let list = res.data.list;

    let newArr = [];
    for (let item of list) {
      let newObj = {
        id: parseInt(item.itemValue),
        name: item.itemText
      };
      newArr.push(newObj);
    }
    // 按id（即itemValue）从小到大排序
    newArr.sort((a, b) => a.id - b.id);
    scope[key] = newArr;
  });
}
// 获取数据字典 projectId
export function getDataDictByProjectId(scope, groupChar, key, projectId) {
  let sendObj = {
    groupChar,
    projectId
  };
  findDdItmeMap(sendObj).then(res => {
    let list = res.data.list;

    let newArr = [];
    for (let item of list) {
      let newObj = {
        id: item.itemValue + "",
        name: item.itemText
      };
      newArr.push(newObj);
    }
    scope[key] = newArr;
  });
}

// 获取数据字典集合
export function getDataDictByChars(scope, groupChars, key, projectId) {
  let postParam = {
    groupChars,
    projectId
  };
  findDdItmeByChars(postParam).then(res => {
    if (res.data.code == 200) {
      scope[key] = res.data.data;
    }
  });
}

// 获取crm数据字典
export function getDataDictByCharsCrm(scope, groupChars, key) {
  let postParam = {
    groupChars
  };
  findDdItmeByCharsCrm(postParam).then(res => {
    if (res.data.code == 200) {
      scope[key] = res.data.data[groupChars];
    }
  });
}

// 从数据字典中 根据 itemValue 返回 文字
export function arrIdCrm(arr, id) {
  let hasVal = false;
  for (let item of arr) {
    if (item.itemValue === id) {
      hasVal = true;
      return item.itemText;
    }
  }

  // 判断 是否为空值
  if (!hasVal) {
    return "";
  }
}

// 从省，市，区 根据 cantonCode 返回 文字
export function arrIdArea(arr, id) {
  let hasVal = false;
  for (let item of arr) {
    if (item.cantonCode === id) {
      hasVal = true;
      return item.cantonName;
    }
  }

  // 判断 是否为空值
  if (!hasVal) {
    return "";
  }
}

// 从数据字典中 根据 ID 返回 文字
export function arrId2Name(arr, id) {
  let hasVal = false;
  for (let item of arr) {
    item.id += "";
    id += "";
    if (item.id === id) {
      hasVal = true;
      return item.name;
    }
  }

  // 判断 是否为空值
  if (!hasVal) {
    return "";
  }
}

// 从数据字典中 根据 ID 返回 文字
export function arrName2Id(arr, name) {
  console.log("====arr", arr);
  let hasVal = false;
  for (let item of arr) {
    if (item.name === name) {
      hasVal = true;
      return item.id;
    }
  }

  // 判断 是否为空值
  if (!hasVal) {
    return "";
  }
}

// 从数据字典中 根据 ID 返回 文字
export function arrId2Row(arr, id) {
  let hasVal = false;
  for (let item of arr) {
    item.id += "";
    id += "";
    if (item.id === id) {
      hasVal = true;
      return item;
    }
  }

  // 判断 是否为空值
  if (!hasVal) {
    return "";
  }
}

// 从数组中 根据 ID 返回 文字, 数组，id值，id对应字段，name对应字段
export function arrId2Name2(arr, id, idText, nameText) {
  let hasVal = false;
  for (let item of arr) {
    if (item[idText] === id) {
      hasVal = true;
      return item[nameText];
    }
  }
  // 判断 是否为空值
  if (!hasVal) {
    return "";
  }
}
// 数组差
export function arrDiff(arr1, arr2) {
  // arrA 大
  let arrA = [];
  let arrB = [];
  if (arr1.length > arr2.length) {
    arrA = arr1;
    arrB = arr2;
  } else {
    arrA = arr2;
    arrB = arr1;
  }

  let objA = {};
  for (let item of arrA) {
    objA[`id_${item.id}`] = item;
  }
  let objB = {};
  for (let item of arrB) {
    objB[`id_${item.id}`] = item;
  }

  let diffArr = [];
  for (let key in objA) {
    console.log("key", key);
    if (!objB[key]) {
      diffArr.push(objA[key]);
    }
  }

  return diffArr;
}
export function arrDiff2(arr1, arr2) {
  // arrA 大
  let arrA = [];
  let arrB = [];
  if (arr1.length > arr2.length) {
    arrA = arr1;
    arrB = arr2;
  } else {
    arrA = arr2;
    arrB = arr1;
  }

  let objA = {};
  for (let item of arrA) {
    objA[`id_${item}`] = item;
  }
  let objB = {};
  for (let item of arrB) {
    objB[`id_${item}`] = item;
  }

  let diffArr = [];
  for (let key in objA) {
    console.log("key", key);
    if (!objB[key]) {
      diffArr.push(objA[key]);
    }
  }

  return diffArr;
}
// 关闭弹窗  作用于，数据对象str，表单str
export function closeDialog(commitKey, scope, formStr) {
  scope.$nextTick(() => {
    scope.$refs[formStr].resetFields();
  });
  store.commit(commitKey, false);
}

// 显示弹窗
export function showDialog(commitKey, type, jsonStr, formData) {
  store.commit(commitKey, true);
  store.commit("SET_PROCESSDIALOGTYPE", "");
  store.commit("SET_PROCESSDIALOGISZHIHUI", false);
  store.commit("SET_PROCESSDIALOGTABLEKEY", "");
  store.commit("SET_PROCESSDIALOGJSONSTR", "");
  setTimeout(() => {
    store.commit("SET_PROCESSDIALOGTYPE", type);
    store.commit("SET_PROCESSDIALOGTABLEKEY", commitKey);
    store.commit("SET_PROCESSDIALOGJSONSTR", jsonStr);
  }, 300);
}

// 知会显示弹窗
export function showDialogZH(commitKey, type, jsonStr, formData) {
  store.commit(commitKey, true);
  store.commit("SET_PROCESSDIALOGTYPE", "");
  store.commit("SET_PROCESSDIALOGISZHIHUI", true);
  store.commit("SET_PROCESSDIALOGTABLEKEY", "");
  store.commit("SET_PROCESSDIALOGJSONSTR", "");
  setTimeout(() => {
    store.commit("SET_PROCESSDIALOGTYPE", type);
    store.commit("SET_PROCESSDIALOGTABLEKEY", commitKey);
    store.commit("SET_PROCESSDIALOGJSONSTR", jsonStr);
  }, 300);
}

// 计算时间差，并保留小数点后一位
export function dateReduce(dateArr) {
  let start = new Date(dateArr[0]);
  let end = new Date(dateArr[1]);
  let timeReduce = end - start;
  timeReduce = timeReduce / 24 / 60 / 60 / 1000;
  timeReduce = Math.round(timeReduce * 10) / 10;
  return timeReduce;
}

// 计算小时数
export function reduce2Xs(dateArr) {
  let start = new Date(dateArr[0]);
  let end = new Date(dateArr[1]);
  let timeReduce = end - start;
  timeReduce = parseInt(timeReduce / 60 / 60 / 1000);
  return timeReduce;
}

// 修改 store 中的状态，先清空，再赋值，解决组件值不存在问题
export function myCommit(commitKey, commitVal) {
  store.commit(commitKey, "");
  setTimeout(() => {
    store.commit(commitKey, commitVal);
  }, 100);
}

// 返回当前月份呢
export function backMonthNow() {
  let dateObj = new Date();
  let month = dateObj.getFullYear() + "-" + return2Num(dateObj.getMonth() + 1);
  return month;
}
// 返回上个月份呢
export function getPreMonth() {
  let dateObj = new Date();
  let month = dateObj.getMonth() + 1;
  let year = dateObj.getFullYear();
  if (month == 1) {
    year--;
    month = 12;
  } else {
    month--;
  }
  month = year + "-" + return2Num(month);
  return month;
}
// base64转file文件
export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(",");
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}
// 】】 自己的

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0;
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  return Math.floor(len);
}

export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

export function param(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"') +
    '"}'
  );
}

export function html2Text(val) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

export function objectMerge(target, source) {
  /* Merges two  objects,
         giving the last one precedence */

  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

export const pickerOptions = [
  {
    text: "今天",
    onClick(picker) {
      const end = new Date();
      const start = new Date(new Date().toDateString());
      end.setTime(start.getTime());
      picker.$emit("pick", [start, end]);
    }
  },
  {
    text: "最近一周",
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit("pick", [start, end]);
    }
  },
  {
    text: "最近一个月",
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit("pick", [start, end]);
    }
  },
  {
    text: "最近三个月",
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit("pick", [start, end]);
    }
  }
];

export function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "shallowClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

// 根据Id 获取 list 中的name
export function getNameById(id, list, idKey = "id", nameKey = "name") {
  let item = list.filter(item => {
    return item[idKey] == id;
  });
  if (item.length > 0) {
    return item[0][nameKey];
  }
  return "";
}

export function formatDate(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  if (parseInt(month) < 10) {
    month = "0" + month;
  }
  if (parseInt(day) < 10) {
    day = "0" + day;
  }

  var newDate = `${year}-${month}-${day}`;
  return newDate;
}

// http url修改
export function objToParam(obj) {
  var params = "?";
  for (let item in obj) {
    var key = item;
    var val = obj[item];
    params += `${key}=${val}&`;
  }
  params = params.substr(0, params.length - 1);
  return params;
}

// http url修改 /a/b/c
export function arrToParam(arr) {
  var params = "";
  for (let item of arr) {
    params += `/${item}`;
  }
  return params;
}

// bpmn 转 activiti
// 去掉xml中的闭合标签，并自闭合
export function bpmnProcess(xmlStr, strArr) {
  let mXml = xmlStr;
  // let mXml = xmlStr.replace(/"/g, 'shuangyinhao')

  for (let item of strArr) {
    let itemArr = mXml.split("<" + item);

    for (let i = 0; i < itemArr.length; i++) {
      if (i !== 0) {
        let arr2 = itemArr[i].split(">");
        // 自闭合
        arr2[0] += "/";
        itemArr[i] = arr2.join(">");
        // 去掉闭合标签
        let arr3 = itemArr[i].split("</" + item + ">");
        let arr4 = arr3[0].split(">");
        for (let y = 0; y < arr4.length; y++) {
          if (y !== 0) {
            arr4[y] = "";
          }
        }
        arr4[0] += ">";
        arr3[0] = arr4.join("");
        itemArr[i] = arr3.join("");
      }
    }
    mXml = itemArr.join("<" + item);
  }
  return mXml;
}
// 去掉xml标签中内容
export function bpmnClearText(xmlStr, strArr) {
  let mXml = xmlStr;
  // let mXml = xmlStr.replace(/"/g, 'shuangyinhao')
  for (let item of strArr) {
    let itemArr = mXml.split("<" + item);
    for (let i = 0; i < itemArr.length; i++) {
      if (i !== 0) {
        let arr2 = itemArr[i].split("</" + item + ">");
        arr2[0] = "";
        itemArr[i] = arr2.join("");
      }
    }
    mXml = itemArr.join("");
  }
  return mXml;
}

// 判断obj是否为空
export function isEmptyObject(obj) {
  return JSON.stringify(obj) === "{}";
}

// 判断是否为空
export function isNull(data) {
  return data === "" || data === undefined || data === null;
}

// 判断是否是数字
// precision-小数点位数
export function strToNum(str, precision = 2) {
  if (!isNull(str)) {
    let number = parseFloat(str);
    if (Object.is(number, NaN)) {
      number = "";
    } else {
      number = num2Round(number, precision);
    }
    return number;
  } else {
    return "";
  }
}

// 判断是否是json
export function isJSON(str) {
  if (typeof str == "string") {
    try {
      let obj = JSON.parse(str);
      if (typeof obj == "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}

// 获取并集
export function getUnionList(arr1, arr2) {
  return arr1.concat(
    arr2.filter(function (val) {
      return !(arr1.indexOf(val) > -1);
    })
  );
}

// 秒转时间
export function second2Time(second) {
  let time = Number(second);
  let perDay = 24 * 60 * 60;
  time = time % perDay;
  let h =
    time / 3600 < 10 ? "0" + parseInt(time / 3600) : parseInt(time / 3600);
  if (h != "00") {
    time = time - h * 3600;
  }
  let m = time / 60 < 10 ? "0" + parseInt(time / 60) : parseInt(time / 60);
  return {
    timeStr: h + ":" + m,
    days: parseInt(second / perDay) + 1
  };
}

// 秒数相加减
export function calcSecond(second, minute) {
  return second + (minute || 0) * 60;
}

// 时间转秒
export function time2Second(time) {
  if (isNull(time)) {
    return 0;
  }
  let hour = parseInt(time.split(":")[0]);
  let minute = parseInt(time.split(":")[1]);
  return hour * 60 * 60 + minute * 60;
}

// 年月日时分 + 分钟 返回最终时间
export function calcDateTime(time0, minute) {
  if (isNull(time0)) {
    return "";
  }
  minute = isNull(minute) ? 0 : minute;
  let dateTime0 = new Date(time0);
  let dateTime0Time = dateTime0.getTime();

  let minuteTime = minute * 60 * 1000;
  dateTime0Time += minuteTime;

  let dateTime1 = new Date(dateTime0Time);
  let year = dateTime1.getFullYear();
  let month = return2Num(dateTime1.getMonth() + 1);
  let day = return2Num(dateTime1.getDate());
  let hours = return2Num(dateTime1.getHours());
  let minutes = return2Num(dateTime1.getMinutes());

  let seconds = return2Num(dateTime1.getSeconds());
  let dateTimeStr = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return dateTimeStr;
}

// 计算时间相差
export function diffTime(endTime, startTime) {
  let start = 0;
  let end = 0;
  if (!isNull(startTime)) {
    start =
      parseInt(startTime.split(":")[0]) * 60 +
      parseInt(startTime.split(":")[1]);
  }
  if (!isNull(endTime)) {
    end =
      parseInt(endTime.split(":")[0]) * 60 + parseInt(endTime.split(":")[1]);
  }
  return Math.abs(end - start);
}

// 计算日期差
export function diffDate(endDate, startDate) {
  return (
    (new Date(endDate + " 00:00:00").getTime() -
      new Date(startDate + " 00:00:00").getTime()) /
    (24 * 60 * 60 * 1000)
  );
}

// 比较时间
export function compareTime(startTime, endTime) {
  let start = 0;
  let end = 0;
  if (!isNull(startTime)) {
    start =
      parseInt(startTime.split(":")[0]) * 60 +
      parseInt(startTime.split(":")[1]);
  }
  if (!isNull(endTime)) {
    end =
      parseInt(endTime.split(":")[0]) * 60 + parseInt(endTime.split(":")[1]);
  }
  return start >= end;
}

// 获取月份最大天数
export function getMaxDate(month) {
  let maxDateList = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return maxDateList[month - 1];
}

// base64转成blob
export function base64ToBlob(code) {
  let parts = code.split(";base64,");
  let contentType = parts[0].split(":")[1];
  let raw = window.atob(parts[1]);
  let rawLength = raw.length;

  let uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], {
    type: contentType
  });
}

// 设置气泡
export function setBubble() {
  // 其他
  let postParam = {
    status: 1
  };
  todoPageWeb(postParam).then(res => {
    if (res.data.code == 200) {
      let data = res.data.data ? res.data.data : {};
      // 待办
      let todoCount = data.todo || 0; // 总待办
      let hrTodoCount = data.todoHr || 0; // hr 待办
      let scTodoCount = data.todoGyl || 0; // 供应链待办
      let fTodoCount = data.todoCw || 0; // 财务待办
      let todoCl = data.todoCl || 0; // 待办 行政管理
      let todoYY = data.todoYY || 0; // 待办 运营管理

      let togoCount = data.togo || 0; // 待发
      let informCount = data.inform || 0; // 知会
      let issuedCount = data.issued || 0; // 已发
      let doneCount = data.done || 0; // 已办

      // 车辆

      // let carNjCount = data.done || 0; // 年检
      // let carBxCount = data.done || 0; // 保险
      // let carYsCount = data.done || 0; // 预算

      let todoParam = {
        todoCount,
        hrTodoCount,
        scTodoCount,
        fTodoCount,
        todoCl,
        todoYY,

        togoCount,
        informCount,
        issuedCount,
        doneCount

        // 车辆
        // carNjCount,
        // carBxCount,
        // carYsCount,
      };
      window.localStorage.todoParam = JSON.stringify(todoParam);

      let totalCount = todoCount + togoCount + informCount;
      // 菜单设置气泡 总数
      if (totalCount > 0) {
        $("i.count-tip.processMan")
          .text(totalCount > 99 ? "99+" : totalCount)
          .show();
      } else {
        $("i.count-tip.processMan").hide();
      }

      // 待办
      if (todoCount > 0) {
        $("i.count-tip.daibanMatter")
          .text(todoCount > 99 ? "99+" : todoCount)
          .show();
      } else {
        $("i.count-tip.daibanMatter").hide();
      }

      // 待发
      if (togoCount > 0) {
        $("i.count-tip.daifaMatter")
          .text(togoCount > 99 ? "99+" : togoCount)
          .show();
      } else {
        $("i.count-tip.daifaMatter").hide();
      }

      // 知会
      if (informCount > 0) {
        $("i.count-tip.zhihuiMatter")
          .text(informCount > 99 ? "99+" : informCount)
          .show();
      } else {
        $("i.count-tip.zhihuiMatter").hide();
      }

      // -- 车辆冒泡
      // // 年检保险
      // let carNjbxTotal = carNjCount + carBxCount
      // if (carNjbxTotal > 0) {
      //   $("i.count-tip.annualInspectionInsurance")
      //     .text(carNjbxTotal > 99 ? "99+" : carNjbxTotal)
      //     .show();
      // } else {
      //   $("i.count-tip.annualInspectionInsurance").hide();
      // }
      // // 年检
      // if (carNjbxTotal > 0) {
      //   $("i.count-tip.annualInspectionInsurance")
      //     .text(carNjbxTotal > 99 ? "99+" : carNjbxTotal)
      //     .show();
      // } else {
      //   $("i.count-tip.annualInspectionInsurance").hide();
      // }
      // // 保险
      // if (carNjbxTotal > 0) {
      //   $("i.count-tip.annualInspectionInsurance")
      //     .text(carNjbxTotal > 99 ? "99+" : carNjbxTotal)
      //     .show();
      // } else {
      //   $("i.count-tip.annualInspectionInsurance").hide();
      // }

      // // 费用管理
      // if (carYsCount > 0) {
      //   $("i.count-tip.vehicleBudgetMaintenance")
      //     .text(carYsCount > 99 ? "99+" : carYsCount)
      //     .show();
      // } else {
      //   $("i.count-tip.vehicleBudgetMaintenance").hide();
      // }
    }
  });

  if (!window.localStorage.userRoles) {
    return false;
  }
  let userRoles = window.localStorage.userRoles;
  let roles = JSON.parse(decodeURI(userRoles));

  if (roles.indexOf("xingzhengoa") >= 0) {
    getOAMaopao().then(res => {
      if (res.data) {
        let data = res.data;
        let todo = data.todo || 0;
        let cc = data.cc || 0;

        let total = todo + cc;

        if (todo > 0) {
          $("i.count-tip.unFinished")
            .text(todo > 99 ? "99+" : todo)
            .show();
        } else {
          $("i.count-tip.unFinished").hide();
        }
        if (cc > 0) {
          $("i.count-tip.CcMe")
            .text(cc > 99 ? "99+" : cc)
            .show();
        } else {
          $("i.count-tip.CcMe").hide();
        }
        if (total > 0) {
          $("i.count-tip.administrationOA")
            .text(total > 99 ? "99+" : total)
            .show();
        } else {
          $("i.count-tip.administrationOA").hide();
        }
      }
    });
  }
  if (roles.indexOf("green_renwuzhixing_web") >= 0) {
    let userInfo = JSON.parse(window.localStorage.ERPUserInfo);
    getGreenMaopao({ userId: userInfo.id }).then(res => {
      if (res.data) {
        let todo = res.data.data || 0;
        if (todo > 0) {
          $("i.count-tip.taskExecute")
            .text(todo > 99 ? "99+" : todo)
            .show();

          $("i.count-tip.maintainMan")
            .text(todo > 99 ? "99+" : todo)
            .show();

          $("i.count-tip.greenMan")
            .text(todo > 99 ? "99+" : todo)
            .show();
        } else {
          $("i.count-tip.taskExecute").hide();
          $("i.count-tip.maintainMan").hide();
          $("i.count-tip.greenMan").hide();
        }
      } else {
        this.$message.error(res.data.msg)
      }
    });
  }
  setRecruitingBubble()
  setQualityControlBubble()
  setCleanOrderBubble()
  setSupplyAssetManMp()
  setExamManBubble()

}
// 设置清洁接单气泡

export function setRecruitingBubble() {
  let userRoles = window.localStorage.userRoles;
  let roles = JSON.parse(decodeURI(userRoles));
  if (roles.indexOf("rec_gangweishuomingshushenpi") >= 0) {
    getJobDescriptionMaopao().then(res => {

      if (res.data) {
        let data = res.data.data || {};
        if ( data && data.jobCoun && data.jobCount > 0 ) {
          $("i.count-tip.recruiting")
            .text(data.jobCount > 99 ? "99+" : data.jobCount)
            .show();

          $("i.count-tip.jobDescriptionMan")
            .text(data.jobCount > 99 ? "99+" : data.jobCount)
            .show();

          $("i.count-tip.examineApprove")
            .text(data.jobCount > 99 ? "99+" : data.jobCount)
            .show();

        } else {
          $("i.count-tip.recruiting").hide();
          $("i.count-tip.jobDescriptionMan").hide();
          $("i.count-tip.examineApprove").hide();
        }

      } else {
        this.$message.error(res.data.msg)
      }
    })

  }

}
export function setCleanOrderBubble() {
  let userRoles = window.localStorage.userRoles;
  let roles = JSON.parse(decodeURI(userRoles));
  if (roles.indexOf("ven_qingjiejiedan") >= 0) {
    getCleanOrderMaopao().then(res => {
      if (res.data) {
        let data = res.data.data || {};
        if (data > 0) {
          $("i.count-tip.siteMan")
            .text(data.kehujiancha > 99 ? "99+" : data)
            .show();

          $("i.count-tip.siteCleanMan")
            .text(data.kehujiancha > 99 ? "99+" : data)
            .show();

          $("i.count-tip.cleanOrders")
            .text(data.kehujiancha > 99 ? "99+" : data)
            .show();

        } else {
          $("i.count-tip.siteMan").hide();
          $("i.count-tip.siteCleanMan").hide();
          $("i.count-tip.cleanOrders").hide();
        }

      } else {
        this.$message.error(res.data.msg)
      }
    })

  }
}
// 设置品质气泡
export function setQualityControlBubble() {
  try {
    // 获取并验证用户角色信息
    const userRoles = window.localStorage.getItem('userRoles');
    const roles = JSON.parse(decodeURI(userRoles));
    
    // 创建角色映射以提高性能（O(1)查找替代O(n)查找）
    const roleMap = createRoleMap(roles);
    
    // 检查用户是否有任何相关权限
    if (!hasAnyRelevantPermission(roleMap)) {
      return;
    }

    // 获取用户信息
    const userInfoStr = window.localStorage.getItem('ERPUserInfo');
    const userInfo = JSON.parse(userInfoStr);
    
    // 获取品质气泡数据
    getQualityMaopao(userInfo.id).then(res => {
        if (!res || !res.data) {
          console.error('获取品质气泡数据失败：响应数据为空');
          return;
        }
        
        const data = res.data.data || {};
        
        // 初始化计数器
        let counters = {
          qualityControl: 0,      // 品质控制总数
          checkManagement: 0,     // 品质核查-检查管理总数
          questionSeeking: 0,     // 品质核查-问题征询总数
          inspectionManagement: 0 // 巡检管理-巡检整改-整改执行总数
        };
        
        // 处理各种类型的气泡显示
        processCustomerRectificationBubbles(data, roleMap, counters);
        processInspectionRectificationBubbles(data, roleMap, counters);
        processCyclePlanAuditBubbles(data, roleMap, counters);
        processCheckManagementBubbles(data, roleMap, counters);
        processQuestionSeekingBubbles(data, roleMap, counters);
        processTopLevelMenuBubbles(data, roleMap, counters);
        
    })
  } catch (error) {
    console.error('设置品质控制气泡时发生错误:', error);
  }
}

/**
 * 创建角色映射以提高查找性能
 * @param {Array} roles - 用户角色数组
 * @returns {Object} 角色映射对象
 */
function createRoleMap(roles) {
  const roleMap = {};
  roles.forEach(role => {
    roleMap[role] = true;
  });
  return roleMap;
}

/**
 * 检查用户是否有任何相关权限
 * @param {Object} roleMap - 角色映射对象
 * @returns {boolean} 是否有权限
 */
function hasAnyRelevantPermission(roleMap) {
  return roleMap["pzkz_kehujianchazhenggai"] || 
         roleMap["pzkz_xunjianzhenggai"] || 
         roleMap["pzkz_pinzhihecha"] || 
         roleMap["zqxgzjh_jhsh_web"];
}

/**
 * 更新气泡显示
 * @param {string} selector - jQuery选择器
 * @param {number} count - 显示数量
 */
function updateBubble(selector, count) {
  const $element = $(`i.count-tip.${selector}`);
  if (count > 0) {
    $element
      .text(count > 99 ? "99+" : count)
      .show();
  } else {
    $element.hide();
  }
}

/**
 * 处理客户检查整改气泡
 * @param {Object} data - 气泡数据
 * @param {Object} roleMap - 角色映射
 * @param {Object} counters - 计数器对象
 */
function processCustomerRectificationBubbles(data, roleMap, counters) {
  if (roleMap["pzkz_khjczg_zhenggaichuli"] && data.kehujiancha > 0) {
    counters.qualityControl += data.kehujiancha;
    updateBubble('customerRectification', data.kehujiancha);
    updateBubble('rectificationHandling', data.kehujiancha);
  } else {
    $("i.count-tip.customerRectification, i.count-tip.rectificationHandling").hide();
  }
}

/**
 * 处理巡检整改气泡
 * @param {Object} data - 气泡数据
 * @param {Object} roleMap - 角色映射
 * @param {Object} counters - 计数器对象
 */
function processInspectionRectificationBubbles(data, roleMap, counters) {
  if (roleMap["pzkz_xjzg_zhenggaizhixing"] && data.xunjianzhengai > 0) {
    counters.inspectionManagement += data.xunjianzhengai;
    updateBubble('inspectionRectification', data.xunjianzhengai);
    updateBubble('rectificationExecution', data.xunjianzhengai);
  } else {
    $("i.count-tip.inspectionRectification, i.count-tip.rectificationExecution").hide();
  }
}

/**
 * 处理周期性工作计划审核气泡
 * @param {Object} data - 气泡数据
 * @param {Object} roleMap - 角色映射
 * @param {Object} counters - 计数器对象
 */
function processCyclePlanAuditBubbles(data, roleMap, counters) {
  const cyclePlanCount = (data.firstAuditCount || 0) + (data.secondAuditCount || 0);
  if (roleMap["zqxgzjh_jhsh_web"] && cyclePlanCount > 0) {
    counters.inspectionManagement += cyclePlanCount;
    updateBubble('CyclePlanAudit', cyclePlanCount);
    updateBubble('CyclePlanPlanManagement', cyclePlanCount);
    updateBubble('CyclePlan', cyclePlanCount);
  } else {
    $("i.count-tip.CyclePlanAudit, i.count-tip.CyclePlanPlanManagement, i.count-tip.CyclePlan").hide();
  }
}

/**
 * 处理品质检查管理气泡
 * @param {Object} data - 气泡数据
 * @param {Object} roleMap - 角色映射
 * @param {Object} counters - 计数器对象
 */
function processCheckManagementBubbles(data, roleMap, counters) {
  // 整改执行
  if (roleMap["pzkz_pzhc_jc_zhenggaizhixing"] && data.hechajiancha > 0) {
    counters.checkManagement += data.hechajiancha;
    updateBubble('workItemSetup', data.hechajiancha);
  } else {
    updateBubble('workItemSetup', 0);
  }
  
  // 整改监管
  if (roleMap["pzkz_pzhc_jc_zhenggaijianguan"] && data.zhenggaijianguan > 0) {
    counters.checkManagement += data.zhenggaijianguan;
    updateBubble('workScheduleSetup', data.zhenggaijianguan);
  } else {
    updateBubble('workScheduleSetup', 0);
  }
  
  // 任务执行
  if (roleMap["pzkz_pzhc_jc_renwuguanli"] && data.renwuzhixing > 0) {
    counters.checkManagement += data.renwuzhixing;
    updateBubble('taskManagement', data.renwuzhixing);
  } else {
    updateBubble('taskManagement', 0);
  }
  
  // 检查管理汇总
  if (roleMap["pzkz_pzhc_jianchaguanli"]) {
    updateBubble('checkManagement', counters.checkManagement);
  } else {
    updateBubble('checkManagement', 0);
  }
}

/**
 * 处理问题征询管理气泡
 * @param {Object} data - 气泡数据
 * @param {Object} roleMap - 角色映射
 * @param {Object} counters - 计数器对象
 */
function processQuestionSeekingBubbles(data, roleMap, counters) {
  // 问题征询-整改执行
  if (roleMap["pzkz_pzhc_jc_zhenggaizhixing"] && data.hechawentizhengxun > 0) {
    counters.questionSeeking += data.hechawentizhengxun;
    updateBubble('questionWorkItemSetup', data.hechawentizhengxun);
  } else {
    updateBubble('questionWorkItemSetup', 0);
  }
  
  // 问题征询-整理分类
  if (roleMap["pzkz_pzhc_zx_zhenglifenlei"] && data.wtzxzhenglifenlei > 0) {
    counters.questionSeeking += data.wtzxzhenglifenlei;
    updateBubble('collationClassification', data.wtzxzhenglifenlei);
  } else {
    updateBubble('collationClassification', 0);
  }
  
  // 问题征询-任务执行
  if (roleMap["pzkz_pzhc_zx_renwuguanli"] && data.wtzxrenwuzhixing > 0) {
    counters.questionSeeking += data.wtzxrenwuzhixing;
    updateBubble('wtzxtaskManagement', data.wtzxrenwuzhixing);
  } else {
    updateBubble('wtzxtaskManagement', 0);
  }
  
  // 问题征询-整改监管
  if (roleMap["pzkz_pzhc_zx_zhenggaijianguan"] && data.wtzxzhenggaijianguan > 0) {
    counters.questionSeeking += data.wtzxzhenggaijianguan;
    updateBubble('wtzxworkScheduleSetup', data.wtzxzhenggaijianguan);
  } else {
    updateBubble('wtzxworkScheduleSetup', 0);
  }
  
  // 问题征询-整改计划
  if (roleMap["pzkz_pzhc_zx_zhenggaijihua"] && data.wtzxzhenggaijihua > 0) {
    counters.questionSeeking += data.wtzxzhenggaijihua;
    updateBubble('questionRectificationPlan', data.wtzxzhenggaijihua);
  } else {
    updateBubble('questionRectificationPlan', 0);
  }
  
  // 问题征询管理汇总
  if (roleMap["pzkz_pzhc_wentizhengxunguanli"]) {
    updateBubble('questionSeekingManagement', counters.questionSeeking);
  } else {
    updateBubble('questionSeekingManagement', 0);
  }
}

/**
 * 处理顶层菜单气泡
 * @param {Object} data - 气泡数据
 * @param {Object} roleMap - 角色映射
 * @param {Object} counters - 计数器对象
 */
function processTopLevelMenuBubbles(data, roleMap, counters) {
  console.log(data, roleMap, counters, "processTopLevelMenuBubbles");
  
  // 外层菜单-品质核查
  if (roleMap["pzkz_pinzhihecha"] && (counters.questionSeeking > 0 || counters.checkManagement > 0)) {
    counters.qualityControl = counters.checkManagement + counters.questionSeeking;
    updateBubble('qualityCheck', counters.qualityControl);
  } else {
    updateBubble('qualityCheck', 0);
  }
  
  // 外层菜单-品质控制
  if (roleMap["pinzhikongzhi_web"] && counters.qualityControl > 0) {
    const pzkzCount = counters.qualityControl + (data.kehujiancha || 0) + (data.xunjianzhengai || 0);
    updateBubble('qualityControl', pzkzCount);
  } else {
    updateBubble('qualityControl', 0);
  }
  
  // 外层菜单-巡检管理
  if (roleMap["pinzhixitong"] && counters.inspectionManagement > 0) {
    updateBubble('qualitySystem', counters.inspectionManagement);
  } else {
    updateBubble('qualitySystem', 0);
  }
}

// 设置车辆管理 冒泡
export function setCarNavMp() {
  getAction("/crm/vehicle/vii/inspection").then(res => {
    if (res.data.code == 200) {
      let data = res.data.data ? res.data.data : {};
      // 车辆
      let carNjCount = data.inspection || 0; // 年检
      let carBxCount = data.insurance || 0; // 保险
      let carYsCount = data.budget || 0; // 预算
      // 年检
      if (carNjCount > 0) {
        $("i.count-tip.carAnnualInspectionMan")
          .text(carNjCount > 99 ? "99+" : carNjCount)
          .show();
      } else {
        $("i.count-tip.carAnnualInspectionMan").hide();
      }
      // 保险
      if (carBxCount > 0) {
        $("i.count-tip.carInsuranceMan")
          .text(carBxCount > 99 ? "99+" : carBxCount)
          .show();
      } else {
        $("i.count-tip.carInsuranceMan").hide();
      }

      // 预算
      if (carYsCount > 0) {
        $("i.count-tip.vehicleBudgetMaintenance")
          .text(carYsCount > 99 ? "99+" : carYsCount)
          .show();
      } else {
        $("i.count-tip.vehicleBudgetMaintenance").hide();
      }
    }
  });
}

// 设置固定资产 到货验收通知 冒泡
export function setSupplyAssetManMp() {
  postAction("/chain/assets/notice/acceptedCount").then((res) => {
    if (res.data.code === "200") {
      let data = res.data.data ? res.data.data : {};
      let count = data.acceptedCount || 0;

      if (count > 0) {
        $("i.count-tip.supplyAssetMan")
          .text(count > 99 ? "99+" : count)
          .show();
        $("i.count-tip.acceptance")
          .text(count > 99 ? "99+" : count)
          .show();
      } else {
        $("i.count-tip.supplyAssetMan").hide();
        $("i.count-tip.acceptance").hide();
      }
    }
  });
}
// 教培管理-在线学习/在线考试 冒泡（课程学习、题库训练）
export function setExamManBubble() {
  // 课程/考试未处理数量
  postAction('/learn/api/course/course/count-maopao').then(res => {
    if (res && res.data && (res.data.code === 200 || res.data.code === '200')) {
      const d = res.data.data || {}
      const courseCount = d.courseCount || 0
      const examCount = d.examCount || 0
      const jpCount = courseCount + examCount

      if (jpCount > 0) {
        $("i.count-tip.examMan").text(jpCount > 99 ? '99+' : jpCount).show()
      } else {
        $("i.count-tip.examMan").hide()
      }
      if (courseCount > 0) {
        $("i.count-tip.studyOnline").text(courseCount > 99 ? '99+' : courseCount).show()
        $("i.count-tip.kechengxuexi").text(courseCount > 99 ? '99+' : courseCount).show()
      } else {
        $("i.count-tip.studyOnline").hide()
        $("i.count-tip.kechengxuexi").hide()
      }
      if (examCount > 0) {
        $("i.count-tip.examOnline").text(examCount > 99 ? '99+' : examCount).show()
        $("i.count-tip.zaixiankaoshi").text(examCount > 99 ? '99+' : examCount).show()
      } else {
        $("i.count-tip.examOnline").hide()
        $("i.count-tip.zaixiankaoshi").hide()
      }
    }
  })
}


// 电话号校验
export function checkPhone(rule, value, callback) {
  const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
  if (!value) {
    return callback(new Error("电话号码不能为空"));
  }
  setTimeout(() => {
    if (!Number.isInteger(+value)) {
      callback(new Error("请输入数字值"));
    } else {
      if (phoneReg.test(value)) {
        callback();
      } else {
        callback(new Error("电话号码格式不正确"));
      }
    }
  }, 100);
}
// 邮箱校验
export function checkEmail(rule, value, callback) {
  const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
  if (!value) {
    return callback(new Error("邮箱不能为空"));
  }
  setTimeout(() => {
    if (mailReg.test(value)) {
      callback();
    } else {
      callback(new Error("请输入正确的邮箱格式"));
    }
  }, 100);
}

// -- << mzg
// 批量获取数据字典 批量
export function getDbItems(scope, keyList) {
  return new Promise((resolve, reject) => {
    let dbKeyList = [];
    let pageSelectKeyList = [];
    for (let item of keyList) {
      dbKeyList.push(item.dbKey);
      pageSelectKeyList.push(item.pageSelectKey);
    }
    let sendObj = {
      groupChars: dbKeyList.join(",")
    };
    erpFindDdItmeByChars(sendObj).then(res0 => {
      let res = res0.data;
      // console.log(res)
      let obj = res.data;
      for (let item of keyList) {
        let resList0 = obj[item.dbKey];
        let resList = [];
        for (let item1 of resList0) {
          let resList0ItemObj = {
            id: item1.itemValue + "",
            name: item1.itemText
          };
          resList.push(resList0ItemObj);
        }
        resList.reverse();
        // console.log('item.pageSelectKey', item.pageSelectKey)
        // console.log('resList', resList)
        scope[item.pageSelectKey] = resList;
        resolve();
      }
    });
  });
}
// 数据字典-全是汉字
export function getDbItems2(scope, keyList) {
  return new Promise((resolve, reject) => {
    let dbKeyList = [];
    let pageSelectKeyList = [];
    for (let item of keyList) {
      dbKeyList.push(item.dbKey);
      pageSelectKeyList.push(item.pageSelectKey);
    }
    let sendObj = {
      groupChars: dbKeyList.join(",")
    };
    erpFindDdItmeByChars(sendObj).then(res0 => {
      let res = res0.data;
      // console.log(res)
      let obj = res.data;
      for (let item of keyList) {
        let resList0 = obj[item.dbKey];
        let resList = [];
        for (let item1 of resList0) {
          let resList0ItemObj = {
            id: item1.itemText,
            name: item1.itemText
          };
          resList.push(resList0ItemObj);
        }
        resList.reverse();
        // console.log('item.pageSelectKey', item.pageSelectKey)
        // console.log('resList', resList)
        scope[item.pageSelectKey] = resList;
        resolve();
      }
    });
  });
}
// 身份证号 获取 性别 年龄
export let getInfoByIdNumber = idNumber => {
  if (!regs.sfzReg.test(idNumber)) {
    return "";
  }

  // 出生日期
  let year = idNumber.substr(6, 4);
  let month = idNumber.substr(10, 2);
  let day = idNumber.substr(12, 2);

  // 周岁
  let nowDate = new Date();
  let birthDate = new Date(year, month - 1, day);
  let charDate = nowDate - birthDate;

  let idNumberAge = charDate / 1000 / 60 / 60 / 24 / 365;
  idNumberAge = parseInt(idNumberAge);
  let sex = parseInt(idNumber.substr(16, 1));
  if (sex % 2 == 1) {
    sex = "男";
  } else {
    sex = "女";
  }
  let info = {
    sex,
    age: idNumberAge
  };
  return info;
};
// -- >> mzg

let debounceTimer = null;
export function debounceFunc(duration = 500) {
  return new Promise((resolve, reject) => {
    if (!isNull(debounceTimer)) {
      clearTimeout(debounceTimer);
    }
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      resolve();
    }, duration);
  });
}

function getDataByKey(key) { }
// 获取缓存变量
export function getConstDict(key) {
  return new Promise((resolve, reject) => {
    let constDictObj;

    if (window.sessionStorage.constDictObj) {
      constDictObj = JSON.parse(window.sessionStorage.constDictObj);
      if (constDictObj[key]) {
        resolve(constDictObj[key]);
      } else {
        resolve(getDataByKey(key));
      }
    } else {
      constDictObj = {};
    }
  });
}

// 报销单，还款-冲借款获取详情
export function getCjkListByIds(ids) {
  return new Promise((resolve, reject) => {
    getAction('/finance/listLoanById?ids=' + ids).then(res0 => {
      let res = res0.data;
      if (res.code == 200) {
        let map = {}
        for (let item of res.list) {
          map['id_' + item.id] = item
        }
        resolve(map)
      } else {
        reject(res.msg)
      }
    })
  });
}

/**
 * 获取当前月份的默认日期范围
 *
 * @returns 返回当前月份的第一天和最后一天，格式为字符串数组，例如 ['2023-10-01', '2023-10-31']
 */
export function getDefaultDateRange() {
  const currentMonth = new Date();

  // 获取当前月份的第一天
  const startOfMonth = new Date(currentMonth);
  startOfMonth.setDate(1); // 将日期设置为当前月的第一天

  // 获取当前月份的最后一天
  const endOfMonth = new Date(currentMonth);
  endOfMonth.setMonth(currentMonth.getMonth() + 1, 0); // 设置为下一个月的第一天，然后减去一天得到当前月的最后一天

  // 使用 toISOString() 方法并截取日期部分
  const startDate = startOfMonth.toISOString().split('T')[0];
  const endDate = endOfMonth.toISOString().split('T')[0];

  return [startDate, endDate];
}

// blob To param
export const blobToParams = (data) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    let result = null
    if (data instanceof Blob) {
      reader.readAsText(data, 'GB2312')
      reader.onload = (e) => {
        result = JSON.parse(reader.result)
        resolve(result)

      }
    }
  })
}